import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import Flex from '@wix/da-ds/pkg/Flex';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField/SelectField';
import { DiscountFormField } from '../../../types';

interface Props {
  inputClassName?: string;
}

const AppliesToSelector: FC<Props> = ({ inputClassName }) => {
  const { t } = useTranslation();
  const { control, errors, watch } = useFormContext();
  const appliesToCategory = watch(DiscountFormField.AppliesToCategory);

  return (
    <Flex direction="row" gap={24}>
      <Controller
        name={DiscountFormField.AppliesToCategory}
        control={control}
        defaultValue={null}
        render={({ onChange, value, name }) => {
          const error = errors[name];
          return (
            <SelectField
              id={DiscountFormField.AppliesToCategory}
              name={DiscountFormField.AppliesToCategory}
              className={inputClassName}
              label={t(
                'studio.discountModal.form.appliesToCategoryInput.label'
              )}
              value={value}
              onChange={onChange}
              error={error?.message}
              isRequired
              items={[
                {
                  label: t(
                    'studio.discountModal.form.appliesToCategoryInput.option.shop_products'
                  ),
                  value: 'shop_products',
                },
                {
                  label: t(
                    'studio.discountModal.form.appliesToCategoryInput.option.subscriptions'
                  ),
                  value: 'subscriptions',
                },
              ]}
              noBottomSpacing={false}
            />
          );
        }}
      />
      {appliesToCategory === 'shop_products' && (
        <Controller
          name={DiscountFormField.AppliesToProduct}
          control={control}
          render={({ onChange, value, name }) => {
            const error = errors[name];
            return (
              <SelectField
                id={DiscountFormField.AppliesToProduct}
                name={DiscountFormField.AppliesToProduct}
                className={inputClassName}
                label={t(
                  'studio.discountModal.form.appliesToProductInput.label'
                )}
                value={value}
                onChange={onChange}
                error={error?.message}
                isRequired
                items={[
                  {
                    label: t(
                      'studio.discountModal.form.appliesToProductInput.option.any_shop_product'
                    ),
                    value: 'any_shop_product',
                  },
                  {
                    label: t(
                      'studio.discountModal.form.appliesToProductInput.option.any_exclusive'
                    ),
                    value: 'any_exclusive',
                  },
                  {
                    label: t(
                      'studio.discountModal.form.appliesToProductInput.option.any_pcp'
                    ),
                    value: 'any_pcp',
                  },
                  {
                    label: t(
                      'studio.discountModal.form.appliesToProductInput.option.any_pg'
                    ),
                    value: 'any_pg',
                  },
                ]}
                noBottomSpacing={false}
              />
            );
          }}
        />
      )}
    </Flex>
  );
};
AppliesToSelector.displayName = 'AppliesToSelector';

export default AppliesToSelector;
